(() => {
  const STORAGE_KEY = 'vv-landing-waitlist-shown';

  const overlay = document.querySelector('[data-vv-landing-waitlist-modal]');
  if (!overlay) return;

  const hasFormErrors = Boolean(overlay.querySelector('.vv-landing-modal__error'));

  /** @type {IntersectionObserver | null} */
  let observer = null;
  let hasOpened = false;

  const markShown = () => {
    localStorage.setItem(STORAGE_KEY, '1');
  };

  const showOverlay = () => {
    overlay.hidden = false;
    overlay.classList.add('is-open');
  };

  const openModal = () => {
    if (hasOpened || overlay.classList.contains('is-open')) return;

    hasOpened = true;
    markShown();
    observer?.disconnect();
    showOverlay();
  };

  const closeModal = () => {
    if (!overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  document.querySelectorAll('[data-vv-landing-waitlist-close]').forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  if (hasFormErrors) {
    showOverlay();
    overlay.querySelector('.vv-landing-modal__error')?.scrollIntoView({ block: 'nearest' });
    return;
  }

  const brandSection = document.querySelector('[data-testid="vv-brand-positioning"]');
  if (!brandSection || localStorage.getItem(STORAGE_KEY) === '1') return;

  observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        openModal();
      }
    },
    {
      threshold: 0.25,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  observer.observe(brandSection);
})();
